import * as angular from 'angular';

export default () => {
    return {
        restrict: 'AC',
        scope: {
            url: '@',
            fileName: '@?'
        },
        link: (scope, elem, attrs, controller) => {
            let player = angular.element(elem[0])[0];
            let audio = angular.element(elem[0].querySelectorAll('audio'))[0] as HTMLAudioElement;
            let playButton = angular.element(elem[0].querySelectorAll('.play'))[0];
            let pauseButton = angular.element(elem[0].querySelectorAll('.pause'))[0];
            let rewindButton = angular.element(elem[0].querySelectorAll('.rewind'))[0];
            let forwardButton = angular.element(elem[0].querySelectorAll('.forward'))[0];
            let trackLine = angular.element(elem[0].querySelectorAll('#trackLine'))[0] as any;
            let volumeLine = angular.element(elem[0].querySelectorAll('#volumeLine'))[0] as any;
            let volumeOff = angular.element(elem[0].querySelectorAll('#volumeOff'))[0];
            let volumeOn = angular.element(elem[0].querySelectorAll('#volumeOn'))[0];
            let download = angular.element(elem[0].querySelectorAll('#cc-audio-download'))[0];
            let controls = angular.element(elem[0].querySelectorAll('#controls'))[0];
            scope.audio = audio;
            scope.volumeValue = 0.5;
            trackLine.value = 0;
            scope.hideIcon = false;
            scope.volumeStatus = true;
            scope.audioSrc = audio.src;
            scope.loadAudio = true;
            scope.loading = false;

            let play = () => {
                audio.play();
                scope.hideIcon = true;
                scope.audioLenght = getMinutes(audio.duration) + ':' + getSeconds(audio.duration);
                trackLine.max = audio.duration;
                if (audio.seekable.length === 0) {
                    scope.loading = true;
                }
            };

            let pause = () => {
                audio.pause();
                updateAudio();
                scope.hideIcon = false;
            };

            let rewind = () => {
                trackLine.value -= 5;
                updateCurrentTime();
            };

            let forward = () => {
                trackLine.value = parseInt(trackLine.value) + 5;
                updateCurrentTime();
            };

            let updateAudio = () => {
                if (!scope.loading && audio.seekable.length === 0) {
                    scope.loading = true;
                } else if (audio.seekable.length !== 0) {
                    scope.loading = false
                }

                if (Math.abs(trackLine.value - audio.currentTime) > 0.7) {
                    audio.currentTime = trackLine.value;
                } else {
                    trackLine.value = audio.currentTime;
                }
                trackLine.max = audio.duration;
                scope.audioLenght = getMinutes(audio.duration) + ':' + getSeconds(audio.duration);
                changeTrackColor();
                scope.$apply(() => {
                    scope.audioCurrentMinutes = getMinutes(audio.currentTime);
                    scope.audioCurrentSeconds = getSeconds(audio.currentTime)
                });

            };

            let updateCurrentTime = () => {
                updateAudio();
                changeTrackColor();
            };

            let changeVolumeColor = (value) => {
                volumeLine.style.backgroundImage = ('-webkit-linear-gradient(left ,#21D196 0%,#21D196 ' + 100 * value + '%,#555 ' + 100 * value + '%, #555 100%)');
            };


            let changeTrackColor = () => {
                trackLine.style.backgroundImage = ('-webkit-linear-gradient(left ,#21D196 0%,#21D196 ' + 100 * audio.currentTime / audio.duration + '%,#555 ' + 100 * audio.currentTime / audio.duration + '%, #555 100%)');
            };

            let getMinutes = (timeLength) => {
                if (!timeLength) timeLength = 0;
                let minutes: number = Math.floor(timeLength / 60);
                return (minutes >= 10) ? minutes : "0" + minutes;
            };

            let getSeconds = (timeLength) => {
                if (!timeLength) timeLength = 0;
                let seconds = Math.floor(timeLength % 60);
                return (seconds >= 10) ? seconds : "0" + seconds;
            };


            let endAudio = () => {
                pause();
                audio.currentTime = 0;
                changeTrackColor();
                trackLine.value = audio.currentTime;
            };

            let changeVolume = () => {
                scope.volumeStatus = volumeLine.value > 0;
                scope.volumeValue = volumeLine.value;
                audio.volume = volumeLine.value;
                changeVolumeColor(volumeLine.value);
            };

            let volumeOffFunc = () => {
                scope.volumeValueOld = volumeLine.value;
                scope.volumeValue = 0;
                volumeLine.value = 0;
                audio.volume = 0;
                changeVolumeColor(0);
                scope.volumeStatus = false;
            };

            let volumeOnFunc = () => {
                changeVolumeColor(scope.volumeValueOld);
                audio.volume = scope.volumeValueOld;
                volumeLine.value = scope.volumeValueOld;
                scope.volumeStatus = true;
            };

            scope.getUrl = () => {
                return scope.loadAudio ? attrs.url : '';
            };

            scope.getAudioLink = () => {
                return audio.src;
            };
            scope.getAudioName = () => {
                return attrs.fileName || 'audio.wav';
            };

            let setLoadAudio = () => {
                scope.loadAudio = true;
            };

            trackLine.addEventListener("change", updateCurrentTime, false);
            controls.addEventListener("click", setLoadAudio, false);
            audio.addEventListener("timeupdate", updateAudio, false);
            audio.addEventListener("ended", endAudio, false);
            playButton.addEventListener("click", play, false);
            pauseButton.addEventListener("click", pause, false);
            rewindButton.addEventListener("click", rewind, false);
            forwardButton.addEventListener("click", forward, false);
            volumeLine.addEventListener("change", changeVolume, false);
            volumeOff.addEventListener("click", volumeOffFunc, false);
            volumeOn.addEventListener("click", volumeOnFunc, false);
            changeVolume();
            scope.audioCurrentMinutes = getMinutes(0);
            scope.audioCurrentSeconds = getSeconds(0);

        },
        template: require('./player.html')
    };
}
